import PropTypes from "prop-types";
import { useSelector, shallowEqual } from "react-redux";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { getRobotsMetaTag } from "app/reducers/partnerSelector";

const mapStateToProps = state => {
	const robotsMetaTag = getRobotsMetaTag(state);
	return {
		robotsMetaTag: robotsMetaTag?.merch,
		titleFromSanity: state.brand?.seo?.merch?.metaTitle,
		descriptionFromSanity: state.brand?.seo?.merch?.metaDescription,
	};
};

const MerchandisingListingHeadMetadata = ({ merchandisingLabel }) => {
	const { robotsMetaTag, titleFromSanity, descriptionFromSanity } = useSelector(
		mapStateToProps,
		shallowEqual
	);

	const title = titleFromSanity || "page.title.merch";
	const description = descriptionFromSanity || "page.description.merch";

	return (
		<HeadMetadata
			description={description}
			title={title}
			titleAttributes={{
				label: merchandisingLabel,
			}}
			robotsMetaTag={robotsMetaTag}
		/>
	);
};

MerchandisingListingHeadMetadata.propTypes = {
	merchandisingLabel: PropTypes.string,
};

export default MerchandisingListingHeadMetadata;
